import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Styles from './PageActions.module.scss';

class PageActions extends PureComponent {
  constructor(props) {
    super(props);
    this.container = React.createRef();
  }
  componentDidMount() {
    this.setContainerPadding();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.container !== this.props.container) {
      this.setContainerPadding();
    }
  }

  setContainerPadding() {
    if (this.props.container && !this.props.ignoreBottomPadding) {
      this.props.container.style.paddingBottom = `${this.container.current.offsetHeight}px`;
    }
  }
  render() {
    const { children, wrapperClass } = this.props;

    return (
      <div ref={this.container} className={Styles.container}>
        <div className={classnames(Styles.wrapper, wrapperClass)}>
          {children}
        </div>
      </div>
    );
  }
}

PageActions.propTypes = {
  children: PropTypes.any,
  container: PropTypes.any,
  wrapperClass: PropTypes.string
};

export default PageActions;
